import { useEffect, useState } from 'react';
import { DateTime } from 'luxon';
import { useDispatch, useSelector } from 'react-redux';

import { usePatchProjectMutation } from '@greenkub-fronts/data-access';
import {
  AppDispatch,
  FixMe,
  Project,
  RootState,
} from '@greenkub-fronts/shared/interface';
import {
  addErrorMessage,
  addPositiveMessage,
} from '@greenkub-fronts/domain/snackbar';
import {
  getCurrentProject,
  openModalSignature,
} from '@greenkub-fronts/domain/signature';

import DechargeNonConformite from '../../../ui/web/template/decharge-non-conformite/decharge-non-conformite';
import { useDebounce } from 'react-use';

export interface DechargeNonConformiteFeatureProps {
  sign1Ref: FixMe;
}

const DechargeNonConformiteFeature = (
  props: DechargeNonConformiteFeatureProps
) => {
  const { sign1Ref } = props;

  const dispatch = useDispatch<AppDispatch>();

  const [patchProject] = usePatchProjectMutation();

  const { isSignature, signature, signatures } = useSelector(
    (state: RootState) => state.signature
  );

  const project = useSelector((state: RootState) => getCurrentProject(state));

  /**
   * STATE
   */
  const [body, setBody] = useState<string>();
  const [body2, setBody2] = useState<string>();
  const [lastName, setLastName] = useState<string>();
  const [firstName, setFirstName] = useState<string>();
  const [date] = useState(DateTime.local());

  /**
   * INIT
   */
  useEffect(() => {
    if (!body)
      setBody(
        project?.dechargeNonConformite?.body
          ? project.dechargeNonConformite.body
          : "Atteste sur l'honneur ma volonté de faire installer par la société GREENKUB une construction bois non conforme à ce qui a été déclaré en mairie."
      );
    if (!body2)
      setBody2(
        project?.dechargeNonConformite?.body2
          ? project.dechargeNonConformite.body2
          : "J'accepte d'assumer l'entière responsabilité de cette décision et décharge donc la société GREENKUB de toutes responsabiltiés"
      );
    if (!lastName)
      setLastName(
        project?.dechargeNonConformite?.lastName
          ? project.dechargeNonConformite.lastName
          : project?.customer.lastName
      );
    if (!firstName)
      setFirstName(
        project?.dechargeNonConformite?.firstName
          ? project.dechargeNonConformite.firstName
          : project?.customer.firstName
      );
  }, []);

  /**
   * EDITION
   */

  useDebounce(
    async () => {
      if (isSignature) return;
      updateData();
    },
    2000,
    [body, body2, lastName, firstName, date]
  );

  const updateData = () => {
    if (isSignature) return;
    const dechargeNonConformite = {
      body,
      body2,
      lastName,
      firstName,
    };
    patchProject({
      projectId: project?.id,
      project: { dechargeNonConformite },
    }).then((resp: FixMe) => {
      if (resp.error) {
        dispatch(addErrorMessage(resp.error));
      } else {
        dispatch(addPositiveMessage(resp.data));
      }
    });
  };

  return (
    <DechargeNonConformite
      project={project as Project}
      isSignature={isSignature}
      signature={signature}
      signatures={signatures}
      handleOpenModalSignHandler={(index: number) =>
        dispatch(openModalSignature({ currentIndexSignature: index }))
      }
      sign1Ref={sign1Ref}
      lastName={lastName || ''}
      firstName={firstName || ''}
      setLastName={setLastName}
      setFirstName={setFirstName}
      body={body || ''}
      body2={body2 || ''}
      setBody={setBody}
      setBody2={setBody2}
      date={date as FixMe}
    />
  );
};

export default DechargeNonConformiteFeature;
